import type { Notification, UseNotificationsOptions } from "@/hooks/app/useNotifications";

export type TabKey = "nao_lidas" | "atendimento" | "vendas" | "agenda" | "todas";

export const TABS: { key: TabKey; label: string }[] = [
  { key: "nao_lidas", label: "Não lidas" },
  { key: "atendimento", label: "Atendimento" },
  { key: "vendas", label: "Vendas" },
  { key: "agenda", label: "Agenda" },
  { key: "todas", label: "Todas" },
];

/** Abas agregam categorias v2: Vendas = deal+lead+coaching (feedback do gestor), Agenda = activity. */
export function tabToOptions(tab: TabKey): UseNotificationsOptions {
  switch (tab) {
    case "todas":
      return {};
    case "nao_lidas":
      return { unreadOnly: true };
    case "atendimento":
      return { categories: ["atendimento"] };
    case "vendas":
      return { categories: ["deal", "lead", "coaching"] };
    case "agenda":
      return { categories: ["activity"] };
  }
}

export const TAB_EMPTY_STATE: Record<TabKey, { title: string; description: string }> = {
  nao_lidas: {
    title: "Tudo lido",
    description: "Você está em dia com suas notificações.",
  },
  atendimento: {
    title: "Nenhuma conversa pendente",
    description: "Conversas sem resposta e repasses da IA aparecem aqui.",
  },
  vendas: {
    title: "Nada em vendas",
    description: "Leads atribuídos a você, feedbacks do gestor e negócios ganhos, perdidos ou parados aparecem aqui.",
  },
  agenda: {
    title: "Agenda em dia",
    description: "Reuniões próximas e atividades vencendo aparecem aqui.",
  },
  todas: {
    title: "Nenhuma notificação",
    description: "Atualizações dos seus negócios, leads e atendimentos aparecem aqui.",
  },
};

/** Separa por estado de leitura preservando a ordem (por data) que já vem do hook. */
export function splitByReadState(items: Notification[]): {
  novas: Notification[];
  anteriores: Notification[];
} {
  const novas: Notification[] = [];
  const anteriores: Notification[] = [];
  for (const n of items) {
    (n.is_read ? anteriores : novas).push(n);
  }
  return { novas, anteriores };
}
